<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-06 09:39:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-09 10:04:47
 * @FilePath: \YunYin_admin\src\views\Village\SetQuery\Role.vue
-->
<template>
  <RoleList :systemType="4"></RoleList>
</template>

<script>
import RoleList from "@/components/Query/RoleList";
export default {
  name: "Role",
  data() {
    return {};
  },
  components: { RoleList },
  filters: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
